<template>
    <div class="mobile-menu-controls">
        <div class="mobile-menu-controls__slice-wrapper">
            <SliceZone v-if="!user || !user.connected" :slices="slices.filter(filterFactory('header_user_slice'))" :components="components" />
        </div>
        <CountrySelectionDialogTrigger
            v-if="!isMediumScreen"
            :country-slice="countrySlice"
            :locale="locale!"
            class="mobile-menu-controls__country-selection"
        />
    </div>
</template>

<script setup lang="ts">
    import type {CountrySliceSlice} from '@prismicio-types';
    import {components} from '@navbar-unlogged/slices';
    import {SliceZone} from '@prismicio/vue';
    import CountrySelectionDialogTrigger from '../CountrySelectionDialogTrigger.vue';
    import type {SharedSlice} from '@prismicio/types';
    import {useMediaQuery} from '@malt/utils';
    import {computed} from 'vue';
    import type {UserInfo} from '@navbar-unlogged/types/custom';

    defineProps<{
        user: UserInfo | null;
        locale: string;
        slices: SharedSlice[];
        countrySlice: CountrySliceSlice;
    }>();

    // Composables
    const {windowWidth} = useMediaQuery();

    // Computed values
    const isMediumScreen = computed(() => windowWidth.value > 767);

    // Handlers
    function filterFactory(sliceType: string): (slice: SharedSlice) => boolean {
        return (slice: SharedSlice) => slice.slice_type === sliceType;
    }
</script>

<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    .mobile-menu-controls {
        display: flex;
        flex-direction: column;
        align-items: center;

        &__slice-wrapper {
            width: 100%;
        }

        &__country-selection {
            transform: translate(calc(25vw - 13px), -28px);
            .country-global-button {
                transform: translateY(calc(-1 * var(--joy-core-spacing-1)));
            }
        }

        @include mq.screen_md {
            a.sign-up-button {
                display: none;
            }
        }

        @include mq.screen_sm(min) {
            a.sign-in-button {
                display: none !important;
            }
        }
    }
</style>
